import React, { useCallback, useEffect, useState } from "react";
import { Card, Table } from "react-bootstrap";
import moment from "moment";
import PageTitle from "../layouts/PageTitle";
import Spinner from "../components/Common/Spinner";
import SubAdminModal from "../components/Modal/SubAdminModal";
import { deleteSubAdmin, getSubAdmins } from "../../services/Auth/AuthService";
import { notifyError, notifyTopRight } from "../components/Common/Toaster";

const normalizeSubAdminList = (response) => {
  const data = response?.data?.data;
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.list)) return data.list;
  if (Array.isArray(data?.subAdmins)) return data.subAdmins;
  if (Array.isArray(response?.data?.subAdmins)) return response.data.subAdmins;
  return [];
};

export default function SubAdmin() {
  const [loader, setLoader] = useState(false);
  const [subAdmins, setSubAdmins] = useState([]);
  const [showCreateModal, setShowCreateModal] = useState(false);

  const fetchSubAdmins = useCallback(async () => {
    setLoader(true);
    try {
      const response = await getSubAdmins();
      setSubAdmins(normalizeSubAdminList(response));
    } catch (error) {
      notifyError(error.response?.data?.message || "Failed to load sub admins");
      setSubAdmins([]);
    } finally {
      setLoader(false);
    }
  }, []);

  useEffect(() => {
    fetchSubAdmins();
  }, [fetchSubAdmins]);

  const handleDelete = async (subAdminId) => {
    if (!subAdminId) return;
    setLoader(true);
    try {
      const response = await deleteSubAdmin(subAdminId);
      notifyTopRight(response?.data?.message || "Sub admin deleted successfully");
      fetchSubAdmins();
    } catch (error) {
      notifyError(error.response?.data?.message || "Failed to delete sub admin");
      setLoader(false);
    }
  };

  return (
    <div>
      <PageTitle activeMenu="Sub Admin" motherMenu="Settings" />
      <Card>
        <Card.Body>
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h4 className="mb-0 text-black">Sub Admins</h4>
            <button
              type="button"
              className="btn btn-primary py-2 px-3"
              onClick={() => setShowCreateModal(true)}
            >
              Add Sub Admin +
            </button>
          </div>

          {loader ? (
            <Spinner />
          ) : (
            <Table responsive className="mostly-customized-scrollbar mb-0 border-top">
              <thead style={{ color: "black" }}>
                <tr>
                  <th>
                    <strong>Username</strong>
                  </th>
                  <th>
                    <strong>Email</strong>
                  </th>
                  <th>
                    <strong>Created At</strong>
                  </th>
                  <th>
                    <strong>Action</strong>
                  </th>
                </tr>
              </thead>
              <tbody>
                {subAdmins.length > 0 ? (
                  subAdmins.map((item, i) => (
                    <tr key={item?._id || item?.id || i} style={{ fontSize: "14px" }}>
                      <td>{item?.username || "-"}</td>
                      <td>{item?.email || "-"}</td>
                      <td>
                        {item?.createdAt
                          ? moment(item.createdAt).format("DD/MM/YYYY, hh:mm A")
                          : "-"}
                      </td>
                      <td>
                        <i
                          className="flaticon-381-trash-1 text-danger"
                          style={{ cursor: "pointer" }}
                          onClick={() => handleDelete(item?._id || item?.id)}
                        />
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={4} className="text-center py-5 text-muted">
                      No sub admins found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          )}
        </Card.Body>
      </Card>

      <SubAdminModal
        show={showCreateModal}
        onHide={() => setShowCreateModal(false)}
        onSuccess={fetchSubAdmins}
      />
    </div>
  );
}
